import { Component, OnInit, Input, ViewChild, OnChanges, OnDestroy, ElementRef } from '@angular/core';
import { LocalStoreService } from "../../services/local-store.service";
const MIN_WIDTH = 3000;
const MIN_HEIGHT = 2000;

@Component({
    selector: 'app-timeline-ruler',
    templateUrl: './timeline-ruler.component.html',
    styleUrls: ['./timeline-ruler.component.scss']
})
export class TimelineRulerComponent implements OnInit, OnChanges, OnDestroy {

    // @Input()
    // set width(i_value) {
    //     if (!i_value) this.width = MIN_WIDTH;
    //     if (parseInt(i_value) < MIN_WIDTH) this.width = MIN_WIDTH;

    //     this.width = i_value;
    // }

    // @Input()
    // set height(i_value) {
    //     if (!i_value) this.height = MIN_HEIGHT;
    //     if (parseInt(i_value) < MIN_HEIGHT) this.height = MIN_HEIGHT;
        
    //     this.height = i_value;
    // }

    @Input() width;
    @Input() height;
    @Input() minWidth;
    @Input() minHeight;
    @Input() position;
    @Input() zoom = 1;
    @Input() scale = 1.0;
    @Input() unitsTime: boolean = true;
    @Input() vertical: boolean = false;

    @ViewChild('myCanvas', { static: true }) canvas: ElementRef;
    public ctx: CanvasRenderingContext2D;
    theme;
    private subscription;

    constructor(private localStoreService: LocalStoreService) {
    }

    ngOnInit() {
        this.theme = this.localStoreService.getStorageValConfig('theme');
        this.subscription = this.localStoreService.theme.subscribe((val) => {
            if (this.theme != val) {
                this.theme = val;
                this.drawScale();
            }
        });
        this.drawScale();
        window.onresize = () => this.drawScale();
    }

    ngOnChanges() {
        this.drawScale();
    }

    ngOnDestroy() {
        this.ctx = null;
        this.canvas = null;
        window.onresize = null;
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    drawScale() {
        this.ctx = (<HTMLCanvasElement>this.canvas.nativeElement).getContext('2d');

        let canvasWidth = parseInt(this.width);
        let canvasHeight = parseInt(this.height);

        if (this.minWidth && canvasWidth < this.minWidth) {
            canvasWidth = this.minWidth;
        }

        if (this.minHeight && canvasHeight < this.minHeight) {
            canvasHeight = this.minHeight;
        }

        this.canvas.nativeElement.width = canvasWidth;
        // this.canvas.width = Math.min(document.getElementById("ruler-container").offsetWidth, canvasWidth);
        this.canvas.nativeElement.height = canvasHeight;

        if (this.theme == '1') {
            this.ctx.fillStyle = '#b0b0b0';
        } else {
            this.ctx.fillStyle = '#323232';
        }

        this.ctx.fillRect(0, 0, canvasWidth, canvasHeight);

        const minorStep = 5;
        const majorStep = 50;
        const minorLineHeight = 10;
        const majorLineHeight = 25;

        const pos = Number(this.position);

        let startPos;

        for (let i = -100; i <= 0; ++i) {
            if ((pos + i) % majorStep == 0 || (pos + i) % minorStep == 0) {
                startPos = i;
                break;
            }
        }
        if (this.theme == '1') {
            this.ctx.fillStyle = '#1b1b1b';
        } else {
            this.ctx.fillStyle = 'rgb(165,165,165)';
        }

        if (this.unitsTime) {
            this.ctx.font = '9px verdana';
        } else {
            this.ctx.font = '9px verdana';
        }

        const endPosition = this.vertical ? canvasHeight + 100 : canvasWidth + 100;

        for (let i = startPos; i <= startPos + endPosition; i += minorStep) {
            const realPosition = pos + i;

            if (realPosition % majorStep == 0) { // draw major step
                if (this.vertical) {
                    this.ctx.fillRect(canvasWidth - majorLineHeight, i, majorLineHeight, 1);
                } else {
                    this.ctx.fillRect(i, canvasHeight - majorLineHeight, 1, majorLineHeight);
                }
                let stepText;
                if (this.unitsTime) {
                    stepText = this.majorStepText(realPosition);
                } else {
                    stepText = this.majorStepText(Math.round(realPosition / this.zoom));
                }

                // draw text
                if (this.vertical) {
                    this.ctx.save();
                    this.ctx.translate(15, i + 5);
                    this.ctx.rotate(-Math.PI / 2);

                    this.ctx.textAlign = 'right';
                    this.ctx.fillText(stepText, 0, 2);

                    this.ctx.restore();
                } else {
                    this.ctx.fillText(stepText, i + 3, 15);
                }

            } else if (realPosition % minorStep == 0) { // draw minor step

                if (this.vertical) {
                    this.ctx.fillRect(canvasWidth - minorLineHeight, i, minorLineHeight, 1);
                } else {
                    this.ctx.fillRect(i, canvasHeight - minorLineHeight, 1, minorLineHeight);
                }
            }
        }
    }

    majorStepText(position) {
        if (this.unitsTime) {
            let totalSeconds = Math.round(position * this.zoom / this.scale);
            const hours = Math.floor(totalSeconds / 60 / 60);
            totalSeconds -= hours * 3600;
            const minutes = Math.floor(totalSeconds / 60);
            totalSeconds -= minutes * 60;
            const seconds = totalSeconds + '';

            const displayHours = hours;
            const displayMinutes = minutes < 10 ? "0" + +minutes : minutes;
            const displaySeconds = seconds.length == 1 ? "0" + seconds : seconds;

            return `${displayHours}:${displayMinutes}:${displaySeconds}`;
        } else {
            return position;
        }
    }

}
